export default __webpack_public_path__ + "static/media/me3_SSO_Lock.ad9cf41f.svg";